import { render, staticRenderFns } from "./InvoicesListFilters.vue?vue&type=template&id=53479610"
import script from "./InvoicesListFilters.vue?vue&type=script&lang=js"
export * from "./InvoicesListFilters.vue?vue&type=script&lang=js"
import style0 from "./InvoicesListFilters.vue?vue&type=style&index=0&id=53479610&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports